import moment from 'moment-timezone'
import dayStartTime from './dayStartTime'

const dayEndTime = moment.utc().local().endOf('day')

export default dayEndTime.diff(dayStartTime, 'minutes')
